<template>
  <div class="flex h-full flex-col">
    <!-- API Mode: Show panel directly in left menu -->
    <SavedBlocksPanel
      v-if="useApiMode"
      :clickable="clickable"
      :section-index="sectionIndex"
      :to-empty="toEmpty"
      @saved-clicked="$emit('saved-clicked', $event)"
    />

    <!-- Legacy mode: signposts + local saved blocks -->
    <template v-else>
      <div v-if="!hidesignpost" class="space-y-2">
        <PremadeHeader
          v-if="savedBlocks"
          data-testid="open-saved-blocks"
          :header-name="$t('forms.saved_blocks')"
          @click="openSavedBlocks"
        />
        <PremadeHeader
          v-if="savedBlocksStore.syncedSectionsEnabled"
          data-testid="open-synced-rows"
          :header-name="$t('forms.synced_rows')"
          @click="SyncedSectionsModalOpen = true"
        />
      </div>
      <SavedBlocks
        v-if="
          !savedBlocksStore.syncedSectionsEnabled ||
          savedBlocksStore.savedBlocksOpened
        "
        :clickable="clickable"
        @saved-clicked="$emit('saved-clicked', $event)"
      />
    </template>
  </div>
</template>
<script lang="ts" setup>
  import PremadeHeader from "../PremadeContainer/_internal/PremadeHeader/PremadeHeader.vue";
  import SavedBlocks from "./SavedBlocks.vue";
  import { api } from "@/api";
  import { useSavedBlocksStore } from "@/stores/savedBlocksStore";
  import { computed, defineAsyncComponent, ref, onMounted } from "vue";

  const SavedBlocksPanel = defineAsyncComponent(
    () => import("./SavedBlocksAPI/SavedBlocksPanel.vue")
  );

  defineProps({
    clickable: {
      type: Boolean,
      default: false,
    },
    sectionIndex: {
      type: Number,
      default: undefined,
    },
    toEmpty: {
      type: Boolean,
      default: false,
    },
  });

  defineEmits(["saved-clicked", "close-dialog"]);

  const savedBlocksStore = useSavedBlocksStore();
  const savedBlocksModalOpen = ref(false);
  const SyncedSectionsModalOpen = ref(false);

  const savedBlocks = computed(() => {
    return savedBlocksStore.savedBlocks;
  });

  // Use API mode when savedBlocks is true (not an array of local blocks)
  const useApiMode = computed(() => {
    return savedBlocks.value === true || api.SAVED_SECTIONS;
  });

  const hidesignpost = computed(() => {
    return (
      (Array.isArray(savedBlocks.value) &&
        !savedBlocksStore.syncedSectionsEnabled) ||
      savedBlocksStore.savedBlocksOpened
    );
  });

  function openSavedBlocks() {
    if (savedBlocks.value === true) {
      savedBlocksModalOpen.value = true;
    } else {
      savedBlocksStore.savedBlocksOpened = true;
    }
  }

  onMounted(() => {
    // Only auto-open modal in legacy mode
    if (!useApiMode.value) {
      if (
        savedBlocks.value === true &&
        !savedBlocksStore.syncedSectionsEnabled
      ) {
        savedBlocksModalOpen.value = true;
      }
      if (
        savedBlocks.value === false &&
        savedBlocksStore.syncedSectionsEnabled
      ) {
        SyncedSectionsModalOpen.value = true;
      }
    }
  });
</script>
